import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  history: null,
  historyPagination: null,

  systems: null,

  cardCurrencies: [],
  bankCurrencies: [],
  cryptoCurrencies: [],

  withdrawStatus: '',
};

export const withdrawSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {
    setWithdrawHistory: (state, action) => {
      state.history = action.payload;
    },
    setWithdrawHistoryPagination: (state, action) => {
      state.historyPagination = action.payload;
    },

    setWithdrawSystems: (state, action) => {
      state.systems = action.payload;
    },

    setWithdrawCardCurrencies: (state, action) => {
      state.cardCurrencies = action.payload;
    },
    setWithdrawBankCurrencies: (state, action) => {
      state.bankCurrencies = action.payload;
    },
    setWithdrawCryptoCurrencies: (state, action) => {
      state.cryptoCurrencies = action.payload;
    },

    setWithdrawStatus: (state, action) => {
      state.withdrawStatus = action.payload;
    },

    resetWithdraw: () => initialState,
  },
});

export const {
  setWithdrawHistory,
  setWithdrawHistoryPagination,

  setWithdrawSystems,

  setWithdrawCardCurrencies,
  setWithdrawBankCurrencies,
  setWithdrawCryptoCurrencies,

  setWithdrawStatus,

  resetWithdraw,
} = withdrawSlice.actions;

export default withdrawSlice.reducer;
